/**
 * De sleutel die bij een veldnaam past: kleine letters, cijfers en liggende streepjes.
 *
 * Apart van het scherm omdat de regel eromheen een test verdient (punt 4 van Extra 2), en een
 * regel die alleen in een `onChange` staat, is niet te testen zonder een browser.
 */
export function suggestFieldKey(value: string): string {
  return value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 64);
}

/**
 * De volgende sleutel, gegeven wat de gebruiker in het naamveld typt.
 *
 * **De sleutel volgt de naam tot iemand hem zelf aanpast.** Dat stond zo in de code als opmerking,
 * maar niet in het gedrag: elke aanslag in het naamveld overschreef de sleutel weer, ook als de
 * beheerder er net met de hand `personeelsnr` van had gemaakt. Wie dat niet merkte, importeerde
 * daarna tegen een kolomnaam die hij nooit gekozen had.
 *
 * `handmatig` is de enige staat die het scherm hoeft bij te houden: eenmaal waar, blijft ze waar
 * zolang de dialoog open is. Opnieuw beginnen doe je door de dialoog te sluiten - en die wordt bij
 * het sluiten leeggemaakt (punt 15).
 */
export function nextFieldKey(input: {
  /** Wat er nu in het naamveld staat. */
  label: string;
  /** Wat er nu in het sleutelveld staat. */
  key: string;
  /** Heeft de gebruiker het sleutelveld zelf aangeraakt? */
  handmatig: boolean;
}): string {
  if (input.handmatig) return input.key;
  return suggestFieldKey(input.label);
}
